// PDF React View
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { downloadPDFInvoices, previewPdfErrorInvoice } from "store/actions";
import "./style.scss";
const ListHDonModal = props => {
  const { isOpen, toggle, dataListHDon } = props;
  const errorInvoices = useSelector(state => state.errorInvoices);
  const { fileDownload, fileDownloadName, type, previewPdfErrorFile } =
    errorInvoices;
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  useEffect(() => {
    if (isOpen) {
    } else {
    }
  }, [isOpen]);

  const LADHDDT_LABEL = {
    1: "HĐĐT theo Nghị định 123/2020/NĐ-CP ( Thông tư 78 )",
    2: "HĐĐT theo Quyết định số 1209/QĐ-BTC ( Thông tư 32 có mã xác thực CQT )",
    3: "HĐĐT theo Nghị định số 51/2010/NĐ-CP ( Thông tư 32 )",
    4: "Hoá đơn đặt in",
  };

  const TCTBAO_LABEL = {
    0: "0 - Mới",
    1: "1 - Hủy",
    2: "2 - Điều chỉnh",
    3: "3 - Thay thế",
    4: "4 - Giải trình",
    5: "5 - Sai sót do tổng hợp",
  };

  return (
    <Modal
      size="xl"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Danh sách hóa đơn sai sót</Label>
        </ModalHeader>
        <ModalBody>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr className="text-info">
                  <th scope="col">STT</th>
                  <th scope="col">Số hóa đơn</th>
                  <th scope="col" style={{ width: "200px" }}>
                    Ký hiệu mẫu số hóa đơn
                  </th>
                  <th scope="col">Ký hiệu hóa đơn</th>
                  <th scope="col">Lý do </th>
                  <th scope="col">Loại áp dụng hóa đơn điện tử</th>
                  <th scope="col">Tính chất thông báo </th>
                  <th scope="col">Ngày lập hóa đơn </th>
                </tr>
              </thead>
              <tbody>
                {dataListHDon &&
                  dataListHDon.cellContent &&
                  dataListHDon.cellContent.map((item, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{item.SHDon}</td>
                      <td>{item.KHMSHDon}</td>
                      <td>{item.KHHDon}</td>
                      <td>{item.LDo}</td>
                      <td>
                        {item.LADHDDT + " - " + LADHDDT_LABEL[item.LADHDDT]}
                      </td>
                      <td>{item.TCTBao + " - " + TCTBAO_LABEL[item.TCTBao]}</td>
                      <td>{item.Ngay}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Dropdown
            className="button-dropdown-pdf"
            direction="left"
            isOpen={dropdownOpen}
            disabled={previewPdfErrorFile.loading}
            toggle={toggleDropdown}
          >
            <DropdownToggle caret>
              {previewPdfErrorFile.loading && (
                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              )}
              Download PDF <i className="fas fa-chevron-up"></i>
            </DropdownToggle>
            <DropdownMenu className="download-dropdown">
              <DropdownItem
                onClick={() => {
                  dispatch(
                    previewPdfErrorInvoice(dataListHDon && dataListHDon.row.id)
                  );
                }}
              >
                Bản hiển thị thông báo
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  dispatch(
                    downloadPDFInvoices(
                      dataListHDon && dataListHDon.row?.id,
                      dataListHDon && dataListHDon.row?.ten,
                      "approve-pdf-error"
                    )
                  );
                }}
              >
                Kết quả CQT phản hồi
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </ModalFooter>
      </div>
    </Modal>
  );
};

ListHDonModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  dataListHDon: PropTypes.any,
};

export default ListHDonModal;
